import EmptyScreen from "components/underConstruction";
import { ArtieIcon } from "icons";
import withStyles from "@material-ui/styles/withStyles";

const styles = () => ({
  marginRoot: {
    margin: "0px !important",
    maxHeight: "85vh",
  },
  text: {
    marginTop: 16,
    fontSize: 16,
    lineHeight: "24px",
  },
});

export default withStyles(styles)(({ text, classes }) => {
  return (
    <EmptyScreen
      text={text}
      icon={<ArtieIcon />}
      className={{ root: classes.marginRoot, text: classes.text }}
    />
  );
});
